import { DataEntryQueueActionTypes } from "../types";
import {
  IDataQueueResponse,
  ISearchQueuePagedResponse,
  IWorkflowItemStep,
  SearchQueuePagedRequest,
} from "../../../../common/sharedTypes";
import Api from "../../../../services/Api";
import { ApiResponse } from "apisauce";
import * as documentDownloadService from "../../../../services/documentDownloadService";
import { b64toBlob } from "../../../PrintPDF/common/utils";
import * as actionTypes from "./actionTypes";
import { toast } from "react-toastify";
import * as urls from "../../../shared/urls";

export const getPaperReports = async (
  url: string,
  request: SearchQueuePagedRequest
): Promise<ApiResponse<ISearchQueuePagedResponse>> => {
  return await Api.post(url, request);
};

export const searchPaperReportsPaged = (url: string, request: SearchQueuePagedRequest) => {
  return async (dispatch) => {
    try {
      dispatch(setLoadingWorkflowSteps(true));
      await getPaperReports(url, request).then(
        (response: ApiResponse<ISearchQueuePagedResponse>) => {
          dispatch(setPaperReports(response.data.workflowItems));
          dispatch(setTotalWorkflowSteps(response.data.totalResults));
        }
      );
    } catch (ex) {
      console.log(ex);
    } finally {
      dispatch(setLoadingWorkflowSteps(false));
    }
  };
};

export const searchPaperReports = (url: string) => {
  return async (dispatch) => {
    try {
      await Api.get(url).then((response: ApiResponse<any>) => {
        dispatch(setPaperReports(response.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const setLoadingWorkflowSteps = (value: boolean) => {
  return {
    type: DataEntryQueueActionTypes.LOADING_WORKFLOW_STEPS,
    value: value,
  };
};

export const setTotalWorkflowSteps = (value: number) => {
  return {
    type: DataEntryQueueActionTypes.TOTAL_WORKFLOW_STEPS,
    value: value,
  };
};

export const setPaperReports = (workflowItems: IDataQueueResponse[]) => {
  return {
    type: DataEntryQueueActionTypes.SEARCH_REPORTS,
    value: workflowItems,
  };
};

export const openReport = (workflowItemStepId: number) => {
  return async (dispatch) => {
    try {
      await Api.post(urls.GET_WORKFLOW_ITEM_STEP, {
        workflowStepItemId: workflowItemStepId,
      }).then((result: ApiResponse<any>) => {
        dispatch(view(result.data));
        if (result.data == null) {
          toast.error("Error opening");
          return Promise.reject(result.data);
        }
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const view = (workflowItemStep: IWorkflowItemStep) => {
  return {
    type: DataEntryQueueActionTypes.OPEN_DATA_ENTRY_REPORT,
    value: workflowItemStep,
  };
};

export const assignAndOpen = (url, stepItemId, assignToId) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowStepItemId: stepItemId,
        assignToUserId: assignToId,
      }).then((result: ApiResponse<any>) => {
        dispatch(reduceAssignAndOpen(result.data));
        if (result.data == null) {
          toast.error("Report already assigned");
          return Promise.reject(result.data);
        }
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const reduceAssignAndOpen = (itemStep: IWorkflowItemStep) => {
  return {
    type: DataEntryQueueActionTypes.ASSIGN_AND_OPEN_REPORT,
    value: itemStep,
  };
};

export const unAssign = (url: string, stepItem: IDataQueueResponse) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowStepItemId: stepItem.id,
      }).then((result: ApiResponse<any>) => {
        dispatch(reduceUnAssign(result.data));
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const reduceUnAssign = (itemStep: IWorkflowItemStep) => {
  return {
    type: DataEntryQueueActionTypes.UNASSIGN,
    value: itemStep,
  };
};

export const saveDataEntry = (
  url: string,
  itemStep: IWorkflowItemStep,
  data: any,
  moveToNextWorkflow: boolean,
  assignNext: boolean
) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowItemStepId: itemStep.id,
        data: JSON.stringify(data),
        complete: moveToNextWorkflow,
        assignNext: assignNext,
      })
        .then((result: ApiResponse<any>) => {
          if (!result.ok) {
            return Promise.reject(result.data);
          }
          if (result.data) {
            dispatch(reduceComplete(result.data));
            const file = b64toBlob(
              result.data.workflowItem.report.paperReport.pdf,
              "application/pdf"
            );
            const fileURL = URL.createObjectURL(file);
            dispatch(reduceImage(fileURL, false));
            dispatch(reduceRemoveFromQueue(itemStep.id));
          }
          return Promise.resolve();
        })
        .catch((e) => {
          return Promise.reject(e);
        });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const reduceComplete = (nextItemStep: IWorkflowItemStep) => {
  return {
    type: DataEntryQueueActionTypes.COMPLETE_DATA_ENTRY,
    value: nextItemStep,
  };
};

export const reduceRemoveFromQueue = (itemStepId: number) => {
  return {
    type: DataEntryQueueActionTypes.REMOVE_FROM_QUEUE,
    value: itemStepId,
  };
};

export const loadImage = (documentId: string, forceNewWindow: boolean) => (dispatch) =>
  new Promise(function (resolve, reject) {
    documentDownloadService.getOnBaseImage(null, documentId).then((response: any) => {
      const file = b64toBlob(response.pdf, "application/pdf");
      const fileURL = URL.createObjectURL(file);
      dispatch(reduceImage(fileURL, forceNewWindow));
      resolve();
    });
  });

export const reduceImage = (fileUrl: string, forceNewWindow: boolean) => {
  return {
    type: DataEntryQueueActionTypes.LOAD_DATA_ENTRY_IMAGE,
    value: { fileUrl, forceNewWindow },
  };
};

export const getFrontSheet = (crashId) => {
  return async (dispatch) => {
    try {
      await documentDownloadService.getFrontSheet(crashId).then((data: any) => {
        dispatch(reduceFrontSheet(data));
        return Promise.resolve(data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const reduceFrontSheet = (frontSheet: Blob) => {
  return {
    type: actionTypes.GET_FRONTSHEET,
    value: frontSheet,
  };
};
